import clsx from 'clsx'
import { SanityRefWithAlt, SanityCustomFile, VideoBlockTypes } from '~/types'
import { getVideoEmbedUrl } from '~/utils'

interface Props {
  videoType: VideoBlockTypes
  videoTitle?: string
  poster?: SanityRefWithAlt
  file?: SanityCustomFile
  mobileFile?: SanityCustomFile
  oembed?: string
  mobileOembed?: string
  autoplay?: boolean
  mobileAutoplay?: boolean
}

const Video = ({
  videoType,
  videoTitle,
  poster,
  file,
  mobileFile,
  oembed,
  mobileOembed,
  autoplay = false,
  mobileAutoplay = false,
}: Props) => {
  return (
    <>
      {videoType == 'file' && file?.asset.url ? (
        <video
          id="videoPlayer"
          autoPlay={autoplay}
          muted={autoplay} // Mute when autoplay is enabled for browser compatibility
          loop
          playsInline
          controls={!autoplay} // Show controls when not autoplaying
          className={clsx('size-full object-cover', [
            { 'hidden md:block': mobileFile?.asset.url },
          ])}
          preload="auto"
          poster={poster?.asset.url}
          title={videoTitle ?? 'video'}
        >
          <track
            default
            kind="captions"
            src=""
          />
          <source
            src={file.asset.url}
            type="video/mp4"
          />
        </video>
      ) : videoType == 'oembed' && oembed && getVideoEmbedUrl(oembed) != '' ? (
        <iframe
          src={getVideoEmbedUrl(oembed, autoplay)}
          title={videoTitle ?? 'Video'}
          className={clsx('size-full', [{ 'hidden md:block': mobileOembed }])}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          loading="lazy"
          allowFullScreen
        />
      ) : null}

      {videoType == 'file'
        ? mobileFile?.asset.url && (
            <video
              id="videoPlayerMobile"
              autoPlay={mobileAutoplay}
              muted={mobileAutoplay} // Mute when autoplay is enabled for browser compatibility
              controls={!mobileAutoplay} // Show controls when not autoplaying
              className="size-full object-cover md:hidden"
              preload="auto"
              poster={poster?.asset.url}
            >
              <track
                default
                kind="captions"
                src=""
              />
              <source
                src={mobileFile.asset.url}
                type="video/mp4"
              />
            </video>
          )
        : mobileOembed &&
          getVideoEmbedUrl(mobileOembed) != '' && (
            <iframe
              src={getVideoEmbedUrl(mobileOembed, mobileAutoplay)}
              title={videoTitle ?? 'Video'}
              className="size-full md:hidden"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              loading="lazy"
              allowFullScreen
            />
          )}
    </>
  )
}

export default Video
